// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import axios from "axios";
import { setSession } from "../utils/sessionstore";
import { encryptHeader } from "../utils/encryptHeader";
import { encryptPassword } from "../utils/encryptPassword";
const API_ENDPOINT = require("../config/server");
const dotenv = require("dotenv");
require("dotenv").config();
const { getSession } = require("../utils/sessionstore");

export async function updateUser(payload) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "UPDATE_USER",
      Method: "PATCH",
    },

    Parameters: {
      data: payload,
    },
  };

  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV":iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
    withCrendentials: true,
  };
  const response = await axios(axiosoptions);
  /// fake commit

  return response.data;
}

export async function changeUserPassword(payload) {
  const encryptedString1 = await encryptPassword(payload.password.trim());
  const encryptedString2 = await encryptPassword(
    payload.currentpassword.trim()
  );

  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "CHANGE_USER_PASSWORD",
      Method: "PATCH",
    },

    Parameters: {
      data: {
        password: encryptedString1,
        currentpassword: encryptedString2,
      },
    },
  };

  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV":iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
    withCrendentials: true,
  };
  const response = await axios(axiosoptions);

  return response.data;
}

//

export async function getUser() {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "GET_USER",
      Method: "GET",
    },

    Parameters: {
      data: {},
    },
  };

  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV":iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
    withCrendentials: true,
  };
  const response = await axios(axiosoptions);

  return response.data;
}
